import React, { useState } from 'react';
import {
  FDBox,
  FDHorizontalTabs, FDStack, FDTabPanel,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { UnexpectedMissingComponent } from 'Organisms/UnexpectedMissingComponent';
import { ProposalProjectionSection } from 'Organisms/ProposalProjectionSection';
import { GoalStrategyOverviewSection } from 'Organisms/GoalStrategyOverviewSection';
import {
  ProposalInflowsSectionTabWrapper,
} from 'Views/Page/Content/Templates/WhatIfClientRedefinedTemplate/MoneyflowsSectionTabs/ProposalInflowsSectionTabWrapper';
import {
  ProposalOutflowsSectionTabWrapper,
} from 'Views/Page/Content/Templates/WhatIfClientRedefinedTemplate/MoneyflowsSectionTabs/ProposalOutflowsSectionTabWrapper';
import { RoadmapExecutiveSummaryLayout } from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryTemplate/Layout';

const LAYOUT_MAP = {
  projection: ProposalProjectionSection,
  'year-ahead-inflow': ProposalInflowsSectionTabWrapper,
  'year-ahead-outflow': ProposalOutflowsSectionTabWrapper,
  'goal-strategy': GoalStrategyOverviewSection,
  'roadmap-summary': RoadmapExecutiveSummaryLayout,
};

export const LayoutTabs = ({ collection }) => {
  const tabOptions = React.useMemo(() => {
    return collection.resources().list().map((res) => {
      return {
        value: res.id(),
        label: res.attr('title'),
        resource: res,
      };
    });
  }, [collection]);
  const [tabId, setTabId] = useState(tabOptions[0]?.value);

  // No tabs if the collection is empty
  if (!tabId) {
    return null;
  }

  return (
    <>
      <FDStack justifyContent={'center'} alignItems={'center'}>
        <FDHorizontalTabs
          options={tabOptions}
          value={tabId}
          onChange={(_, v) => { setTabId(v); }}
        />
      </FDStack>
      {tabOptions.map(({ value, resource }) => {
        const LayoutComponent = LAYOUT_MAP[value] || UnexpectedMissingComponent;
        const [sectionResource] = resource.attr('sections');
        return (
          <FDTabPanel
            key={value}
            id={value}
            value={tabId}
          >
            <FDBox paddingY={5}>
              {/* Show header and footer is false because the client view has it's own header and footer */}
              <LayoutComponent resource={sectionResource} showHeaderAndFooter={false} />
            </FDBox>
          </FDTabPanel>
        );
      })}
    </>
  );
};

LayoutTabs.propTypes = {
  collection: PropTypes.object.isRequired,
};
